import { Lottie } from '@web_opxp/lottie';
import React, { FC } from 'react';

export interface ICelebrationLottieProps {
  name: string;
  show: boolean;
}

export const CelebrationLottie: FC<ICelebrationLottieProps> = ({ name, show }) => {
  if (!show) {
    return null;
  }
  return <Lottie.Component.LottieAnimation name={name} autoplay={true} loop={true} className="achievements-lottie" />;
};

export default CelebrationLottie;
